import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";
// Redux
import { Link, useNavigate } from "react-router-dom";
import withRouter from "../withRouter";

// users
import user1 from "../../../assets/images/users/avatar-1.jpg";
import ChangePasswordModal from "../../ChangePasswordModal";
import ConfirmModal from "../../ConfirmModal";
import callApi from "../../../helpers/CallApi";
import { changePassword } from "../../../helpers/API";
import { toast } from "react-toastify";

const ProfileMenu = (props) => {
  // Declare a new state variable, which we'll call "isMenu"
  const navigate = useNavigate();
  const [isMenu, setIsMenu] = useState(false);
  const [userPic, setUserPic] = useState("");
  const [userData, setUserData] = useState({});
  const [userName, setUserName] = useState("");
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const obj = JSON.parse(storedUser);
      setUserName(obj?.name);
      setUserPic(obj?.profile || "");
      setUserData(obj);
    }
  }, [props.success]);

  // Toggle modal
  const toggleChangePasswordModal = () => {
    setShowChangePasswordModal(!showChangePasswordModal);
  };

  const handleLogoutClick = () => {
    setIsMenu(false);
    setShowLogoutConfirm(true);
  };

  const handleLogoutConfirm = () => {
    setShowLogoutConfirm(false);
    navigate("/logout");
  };

  // Handle password change
  const handlePasswordChange = async (payload) => {
    callApi({
      callback: changePassword,
      payload,
      onSuccess: () => {
        toggleChangePasswordModal();
        toast.success(props.t("profile.messages.changePasswordSuccess"));
        navigate("/logout");
      },
      onError: (message) => {
        toast.error(message);
      },
    });
  };

  return (
    <React.Fragment>
      <Dropdown
        isOpen={isMenu}
        toggle={() => setIsMenu(!isMenu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
            src={userPic || user1}
            alt="Header Avatar"
          />
          <span className="d-none d-xl-inline-block ms-2 me-2">{userName}</span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem tag={Link} to="/userprofile">
            {" "}
            <i className="ri-user-line align-middle me-2" />
            {props.t("Profile")}{" "}
          </DropdownItem>

          {userData?.role === "distributor" && <DropdownItem tag={Link} to="/terms-condition">
            <i className="ri-file-list-3-line align-middle me-2" />
            {props.t("Terms & Condition")}
          </DropdownItem>}
          <DropdownItem tag="button" onClick={toggleChangePasswordModal}>
            <i className="ri-settings-2-line align-middle me-2" />
            {props.t("Password Change")}
          </DropdownItem>
          <DropdownItem tag="a" href="auth-lock-screen">
            <i className="ri-lock-unlock-line align-middle me-2" />
            {props.t("Lock screen")}
          </DropdownItem>
          <div className="dropdown-divider" />
          <DropdownItem tag="button" type="button" onClick={handleLogoutClick}>
            <i className="ri-shut-down-line align-middle me-2 text-danger" />
            <span>{props.t("Logout")}</span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <ChangePasswordModal
        isOpen={showChangePasswordModal}
        toggle={toggleChangePasswordModal}
        onPasswordChange={handlePasswordChange}
      />
      <ConfirmModal
        isOpen={showLogoutConfirm}
        toggle={() => setShowLogoutConfirm(false)}
        variant="LOGOUT"
        showIcon
        confirmColor="danger"
        onConfirm={handleLogoutConfirm}
      >
        <p className="mb-2">{props.t("confirmModal.variants.logout.message")}</p>
        <p className="text-muted small mb-0">
          <i className="ri-information-line me-1" />
          {props.t("confirmModal.variants.logout.hint")}
        </p>
      </ConfirmModal>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
};

const mapStatetoProps = (state) => {
  const success = state?.profile?.success;
  return { success };
};

export default withRouter(withTranslation()(ProfileMenu));
